import isEmpty from 'lodash/isEmpty';

import { RequestDto } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate/dto/RequestDto';

import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import isSpeedRestrictionByEqual100 from '~/src/features/tariffBuilder/selectors/isSpeedRestrictionByEqual100';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

const getRecalculateBody = (state: TInitialState): RequestDto => {
    const entities = state.selectedEntityIds;

    if (!isEmpty(state[EEntity.speed])) {
        return {
            ...(isSpeedRestrictionByEqual100(state) ? {} : { speed: Number(state[EEntity.speed][state.selectedSpeed].speed) }),
            ...entities,
            speedRestrictions: state.speedRestrictions,
        };
    }

    if (state.currentTariff?.speed) {
        return {
            speed: state.currentTariff.speed,
        };
    }

    return {};
};

export default getRecalculateBody;
